import { BrowserRouter } from 'react-router-dom';
import AppRouter from './router/AppRouter';
import { useThemeProvider } from './hooks/useThemeProvider';

const App = () => {
  // Tema değişikliklerini HTML'e yansıt
  useThemeProvider();

  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
};

export default App;
